import { render, staticRenderFns } from "./TagsView.vue?vue&type=template&id=9c48c2be&scoped=true"
import script from "./TagsView.vue?vue&type=script&lang=js"
export * from "./TagsView.vue?vue&type=script&lang=js"
import style0 from "./TagsView.vue?vue&type=style&index=0&id=9c48c2be&prod&lang=scss&scoped=true"
import style1 from "./TagsView.vue?vue&type=style&index=1&id=9c48c2be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c48c2be",
  null
  
)

export default component.exports